import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
}), 'AccessibilityTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AccessibilityTwoTone.js
// module id = 1811
// module chunks = 2